// Администрирование компании. КАРКАС: backend готов.
// Разделы (как в прототипе): Сотрудники, Приглашения, Реквизиты, AI, Безопасность.
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { membersApi, invitesApi } from '@/api';
import { AppLayout, PageHeader, SidebarNav } from '@/components/layout/AppLayout';
import { Spinner } from '@/components/ui/Spinner';
import { StatusBadge } from '@/components/ui/StatusBadge';

const SECTIONS = [
  { key: 'members', label: 'Сотрудники' },
  { key: 'invites', label: 'Приглашения' },
  { key: 'company', label: 'Реквизиты' },
  { key: 'ai', label: 'AI / Нейросети' },
  { key: 'security', label: 'Безопасность' },
  { key: 'billing', label: 'Биллинг' },
];

export function AdminPage() {
  const [section, setSection] = useState('members');
  const sidebar = <SidebarNav title="Администрирование" items={SECTIONS} activeKey={section} onSelect={setSection} />;
  return (
    <AppLayout sidebar={sidebar}>
      {section === 'members' && <MembersSection />}
      {section === 'invites' && <InvitesSection />}
      {section !== 'members' && section !== 'invites' && (
        <>
          <PageHeader title={SECTIONS.find((s) => s.key === section)?.label || ''} />
          <div className="card">
            <p style={{ color: 'var(--text-secondary)' }}>Раздел готов к наполнению — backend API доступен.</p>
          </div>
        </>
      )}
    </AppLayout>
  );
}

function MembersSection() {
  const { data, isLoading } = useQuery({ queryKey: ['members'], queryFn: () => membersApi.list() });
  return (
    <>
      <PageHeader title="Сотрудники" subtitle={data ? `${data.count} сотрудников` : undefined} />
      <div className="panel">
        {isLoading ? <Spinner /> : (
          <table className="data-table">
            <thead><tr><th>Сотрудник</th><th>Email</th><th>Роль</th><th>Статус</th></tr></thead>
            <tbody>
              {data?.results.map((m) => (
                <tr key={m.id}>
                  <td>{m.user_full_name}</td>
                  <td className="mono">{m.user_email}</td>
                  <td>{m.role_display}</td>
                  <td><StatusBadge label={m.is_active ? 'Активен' : 'Отключён'} color={m.is_active ? 'var(--green)' : 'var(--text-muted)'} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

function InvitesSection() {
  const { data, isLoading } = useQuery({ queryKey: ['invites'], queryFn: () => invitesApi.list() });
  return (
    <>
      <PageHeader title="Приглашения" />
      <div className="panel">
        {isLoading ? <Spinner /> : (
          <table className="data-table">
            <thead><tr><th>Email</th><th>Роль</th><th>Код</th><th>Статус</th></tr></thead>
            <tbody>
              {data?.results.map((i) => (
                <tr key={i.id}><td>{i.email}</td><td>{i.role_display}</td><td className="mono">{i.code}</td><td>{i.status}</td></tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
